var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['layout-wrap', _vm.extraClass]},[(!_vm.resetPageHideComponent.includes('topMenu'))?_c('XHeader'):_vm._e(),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('client-only',[(_vm.$store.state.app.showLoginPop)?_c('LoginPop',{style:(_vm.resetPageHideComponent.includes('topMenu') && 'top:0')}):_vm._e()],1),_vm._v(" "),_c('XFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }